import React from 'react';

import { Image } from './../../ui-components';

import AvatarIcon from '../icons/AvatarIcon';
import styles from '../statics/mention-list-scss';

const MentionAvatar = ({ src, alt }: $TSFixMe) => {
  const containerId = `${src}-${alt}-parent`;
  return (
    <div>
      {src ? (
        <Image
          containerId={containerId}
          containerProps={{
            containerId,
          }}
          className={styles.avatar}
          displayMode="fill"
          width={28}
          height={28}
          uri={src}
          alt={alt}
        />
      ) : (
        <AvatarIcon className={styles.avatar} />
      )}
    </div>
  );
};

export default MentionAvatar;
